/* lua.js generated code 0.3.0 */

TileMoveRouteMeta = xClass("TileMoveRouteMeta")
TileMoveRouteMeta.prototype.ctor = function () {
    var self = this
    self.startPos = null
    self.endPos = null
    self.next = null
    self.pre = null
}
TileMoveRouteMeta.prototype.fromMeta = function (posData) {
    var self = this
    var startPosC = posData[1]
    var startPosR = posData[2]
    var endPosC = posData[3]
    var endPosR = posData[4]
    self.o_startPos = IntCoord.create(startPosR, startPosC)
    self.o_endPos = IntCoord.create(endPosR, endPosC)
    self.startPos = IntCoord.create(startPosR, startPosC)
    self.endPos = IntCoord.create(endPosR, endPosC)
}
TileMoveRouteMeta.prototype.moveWithStep = function (r, c, step, isReverse) {
    var self = this
    var leftStep = step
    var [retR, retC] = [r, c]
    var dir = GameItemDirection.kNone
    if (isReverse) {
        dir = TileMoveRouteMeta.prototype.calcDirection(self.endPos, self.startPos)
    } else {
        dir = TileMoveRouteMeta.prototype.calcDirection(self.startPos, self.endPos)
    }
    var endPos = self.endPos
    if (isReverse) {
        endPos = self.startPos
    } // 反向移动
    if (dir === GameItemDirection.kUp) {
        retR = r - step
        if (retR < endPos.x) {
            retR = endPos.x
        }
    } else if (dir === GameItemDirection.kRight) {
        retC = c + step
        if (retC > endPos.y) {
            retC = endPos.y
        }
    } else if (dir === GameItemDirection.kDown) {
        retR = r + step
        if (retR > endPos.x) {
            retR = endPos.x
        }
    } else if (dir === GameItemDirection.kLeft) {
        retC = c - step
        if (retC < endPos.y) {
            retC = endPos.y
        }
    }
    leftStep = leftStep - (Math.abs(r - retR) + Math.abs(c - retC))
    // FIXME: multi result
    return [retR, retC, leftStep]
}
TileMoveRouteMeta.prototype.getDirection = function (isReverse) {
    var self = this
    if (isReverse) {
        // WARN: maybe multi result
        return self.calcDirection(self.endPos, self.startPos)
    } else {
        // WARN: maybe multi result
        return self.calcDirection(self.startPos, self.endPos)
    }
}
TileMoveRouteMeta.prototype.calcDirection = function (startPos, endPos) {
    var self = this
    var dr = endPos.x - startPos.x
    var dc = endPos.y - startPos.y
    if (dr === 0 && dc < 0) {
        return GameItemDirection.kLeft
    } else if (dr === 0 && dc > 0) {
        return GameItemDirection.kRight
    } else if (dc === 0 && dr < 0) {
        return GameItemDirection.kUp
    } else if (dc === 0 && dr > 0) {
        return GameItemDirection.kDown
    }
    return GameItemDirection.kNone
}
TileMoveRouteMeta.prototype.transForRect = function (rect) {
    var self = this
    // body
    self.startPos.x = self.o_startPos.x - rect.x + 1
    self.startPos.y = self.o_startPos.y - rect.y + 1
    self.endPos.x = self.o_endPos.x - rect.x + 1
    self.endPos.y = self.o_endPos.y - rect.y + 1
}
TileMoveRouteMeta.prototype.updateRow = function (step) {
    var self = this
    // body
    self.startPos.x = self.startPos.x - step
    self.endPos.x = self.endPos.x - step
}
TileMoveRouteMeta.prototype.isStartPos = function (r, c) {
    var self = this
    return self.startPos.x === r && self.startPos.y === c
}
TileMoveRouteMeta.prototype.isEndPos = function (r, c) {
    var self = this
    return self.endPos.x === r && self.endPos.y === c
}
TileMoveRouteMeta.prototype.isFinalPos = function (r, c, isReverse) {
    var self = this
    if (isReverse) {
        return !self.pre && self.isStartPos(r, c)
    } else {
        return !self.next && self.isEndPos(r, c)
    }
}
TileMoveMeta = xClass("TileMoveMeta")
TileMoveMeta.prototype.ctor = function () {
    var self = this
    self.step = 0
    self.routes = table()
    self.moveCountDown = 1
}
TileMoveMeta.create = function (meta) {
    var self = this
    // print("TileMoveMeta:create ", meta)
    var tmMeta = TileMoveMeta.new()
    tmMeta.fromMeta(meta)
    return tmMeta
}
TileMoveMeta.prototype.transForRect = function (rect) {
    var self = this
    // body
    for (var k = 1, v = self.routes[1]; v; k++, v = self.routes[k]) {
        v.transForRect(rect)
    }
}
TileMoveMeta.prototype.updateRow = function (step) {
    var self = this
    // body
    for (var k = 1, v = self.routes[1]; v; k++, v = self.routes[k]) {
        v.updateRow(step)
    }
}
TileMoveMeta.prototype.fromMeta = function (meta) {
    var self = this
    self.routes = table()
    if (meta) {
        self.move = meta.step.move
        self.interval = meta.step.interval
        var routesInNumber = meta.pathElements
        if (routesInNumber && $len(routesInNumber) > 0) {
            for (var _ in routesInNumber) {
                var v = routesInNumber[_]
                var route = TileMoveRouteMeta.new()
                route.fromMeta(v)
                table.insert(self.routes, route)
            }
            function findNextRouteByStartPos(pos) {
                for (var _ in self.routes) {
                    var v = self.routes[_]
                    if (v.startPos.x === pos.x && v.startPos.y === pos.y) {
                        return v
                    }
                }
            }
            // 创建双向链表
            for (var _ in self.routes) {
                var route = self.routes[_]
                var nextRoute = findNextRouteByStartPos(route.endPos)
                if (nextRoute) {
                    route.next = nextRoute
                    if (!nextRoute.pre) {
                        nextRoute.pre = route
                    }
                }
            }
        }
    }
}
TileMoveMeta.prototype.findRouteByPos = function (r, c, isReverse) {
    var self = this
    if (isReverse) {
        for (var _ in self.routes) {
            var v = self.routes[_]
            if (r === v.endPos.x && c === v.endPos.y) { // 在终点中找
                return v
            }
        }
    } else {
        for (var _ in self.routes) {
            var v = self.routes[_]
            if (r === v.startPos.x && c === v.startPos.y) { // 在起点中找
                return v
            }
        }
    }
    for (var _ in self.routes) {
        var v = self.routes[_]
        if (r === v.startPos.x && r === v.endPos.x && ((c - v.startPos.y) * (c - v.endPos.y) <= 0)) { // 是否在行中间
            return v
        }
        if (c === v.startPos.y && c === v.endPos.y && ((r - v.startPos.x) * (r - v.endPos.x) <= 0)) { // 是否在列中间
            return v
        }
    }
    return null
}
TileMoveMeta.prototype.findMoveMaxRect = function () {
    let self = this
    let [minX, minY, maxX, maxY] = [0, 0, 0, 0]
    for (let k in self.routes) {
        let v = self.routes[k]
        if ($null(v)) continue
        if (minX === 0) {
            minX = v.o_startPos.x
        }
        if (minY === 0) {
            minY = v.o_startPos.y
        }
        if (maxX === 0) {
            maxX = v.o_startPos.x
        }
        if (maxY === 0) {
            maxY = v.o_startPos.y
        }
        minX = v.o_startPos.x < minX && v.o_startPos.x || minX
        minY = v.o_startPos.y < minY && v.o_startPos.y || minY
        maxX = v.o_startPos.x > maxX && v.o_startPos.x || maxX
        maxY = v.o_startPos.y > maxY && v.o_startPos.y || maxY
        minX = v.o_endPos.x < minX && v.o_endPos.x || minX
        minY = v.o_endPos.y < minY && v.o_endPos.y || minY
        maxX = v.o_endPos.x > maxX && v.o_endPos.x || maxX
        maxY = v.o_endPos.y > maxY && v.o_endPos.y || maxY
    }
    // FIXME: multi result
    return [minY, minX, maxY, maxX]
}
TileMoveConfig = xClass("TileMoveConfig")
TileMoveConfig.prototype.ctor = function () {
    var self = this
    self.tileMoveCfgs = table()
}
TileMoveConfig.create = function (config) {
    var self = this
    var ret = TileMoveConfig.new()
    ret.fromConfig(config)
    return ret
}
TileMoveConfig.prototype.fromConfig = function (config) {
    var self = this
    self.tileMoveCfgs = table()
    if (type(config) === "table" && $len(config) > 0) {
        for (var _ in config) {
            var meta = config[_]
            var tmMeta = TileMoveMeta.create(meta)
            if (tmMeta.step>=0 && $len(tmMeta.routes) > 0) {
                var initPos = tmMeta.routes[1].startPos
                self.tileMoveCfgs[initPos.x + "_" + initPos.y] = tmMeta
            }
        }
    }
}
TileMoveConfig.prototype.findTileMoveMetaByPos = function (r, c) {
    var self = this
    return self.tileMoveCfgs[r + "_" + c]
}
